import { useTranslation } from "react-i18next";
import Input from "react-phone-input-2";
import pt from "react-phone-input-2/lang/pt.json";
import es from "react-phone-input-2/lang/es.json";
import "react-phone-input-2/lib/style.css";
import "./PhoneInput.scss";
import { theme } from "antd";
const { useToken } = theme;

const PhoneInput: React.FC<any> = (props) => {
  const { country = "br", value, onChange } = props;
  const { hashId }: any = useToken();
  const { i18n } = useTranslation();
  const localization: any = {
    pt,
    es,
  };

  return (
    <Input
      value={value}
      // onChange={(value, data: any, event, formattedValue) => {
      //   // console.log(value, data.dialCode, event, formattedValue);
      //   // const regex = /^\+\d{1,3}$/;
      //   // onChange(regex.test(formattedValue) ? "" : value);
      //   onChange(formattedValue);
      // }}
      onChange={onChange}
      containerClass={`phone-input ${hashId}`}
      country={country?.toLowerCase()}
      localization={localization[i18n.language]}
      preferredCountries={["br", "us"]}
    />
  );
};

export default PhoneInput;
